var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 16H30.02",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 40H14C12.4087 40 10.8826 39.3679 9.75736 38.2426C8.63214 37.1174 8 35.5913 8 34V14C8 12.4087 8.63214 10.8826 9.75736 9.75736C10.8826 8.63214 12.4087 8 14 8H34C35.5913 8 37.1174 8.63214 38.2426 9.75736C39.3679 10.8826 40 12.4087 40 14V22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 29.9999L16 21.9999C17.856 20.2139 20.144 20.2139 22 21.9999L28 27.9999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 28.0001L30 26.0001C30.62 25.4041 31.288 25.0061 31.974 24.8081",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.84 31.22C37.23 30.8299 37.6931 30.5205 38.2026 30.3095C38.7122 30.0984 39.2584 29.9897 39.81 29.9897C40.3616 29.9897 40.9078 30.0984 41.4174 30.3095C41.9269 30.5205 42.39 30.8299 42.78 31.22C43.17 31.61 43.4794 32.073 43.6905 32.5826C43.9016 33.0922 44.0102 33.6384 44.0102 34.19C44.0102 34.7415 43.9016 35.2877 43.6905 35.7973C43.4794 36.3069 43.17 36.7699 42.78 37.16L36 44H30V38L36.84 31.22Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/change-icon.e30d2312000fe21a9551905e56a8eda9.svg";
export { ForwardRef as ReactComponent };